export enum NetworkListField {
    LAST_UPDATED = "lastUpdated",
    NETWORKS = "networks"
}
